<template>
    <div class="list ml15 mr15">
        <el-collapse v-model="activeName" accordion>
            <el-collapse-item :name='index' v-for="(order,index) in data" :key="index">
                <template slot="title">
                    <div class="fs14 pl15">{{order.name}}({{order.list.length}})</div>
                </template>
                <div class="main">
                    <ul>
                        <li v-for="(pat,i) in order.list" :key="i" class="pl15 pr15 pt15 pb15" :class="{bt:i>0}">
                            <div class="flex fs14">
                                <span class="flex0 mr5">{{pat.hzxm}}</span>
                                <span class="flex0 mr5">{{pat.xb | formatPatSex}}</span>
                                <span class="flex1">{{pat.age + '岁'}}</span>
                                <span class="flex0">{{pat.yymc}}</span>
                            </div>
                            <div class="flex color_999 fs12 mt5">
                                <span class="mr5">{{pat.ksmc}}-{{pat.ysmc}}</span>
                                <span class="mr5">{{pat.ampm | formatAnpm}} {{pat.numno + '号'}}</span>
                                <span>{{pat.numtime}}</span>
                            </div>
                            <div class="mt5 flex aic">
                                <div class="flex0 flex column aic jcc">
                                    <img :src="order.icon" alt="" width="20">
                                    <span class="flex0 color_main">{{order.name}}</span>
                                </div>
                                <div class="flex1"></div>
                                <div class="flex0">
                                    <span v-for="btn in order.btns" class="ml5" :class="[btn.type]"
                                          @click="handler(btn.name,pat)">{{btn.name}}</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
    import {ONLINE_BTN_MAP, ONLINE_DDZT_BTN} from "../../lib/hos/until"
    export default {
        name: "dis-online-list",
        props: {
            list: {
                type: Array,
                default() {
                    return [];
                }
            },
        },
        filters:{
            formatPatSex(val){
                if(val == undefined || val == ""){
                    return "-"
                }
                return val == "1" ? '男' : '女'
            },
            formatAnpm(val){
                return val == "1" ? '上午' : '下午'
             }
        },
        data(){
            const getBtns = (index) => {
                let btns = ONLINE_DDZT_BTN[index];
                return btns.map(r => {
                    return {
                        name: r,
                        ...ONLINE_BTN_MAP[r]
                    }
                });
            };
            return {
                activeName : "1",
                data: [
                    {name: '待候诊', list: [], icon: require('../../assets/icon/online/候诊中.png'),btns: getBtns(0)},
                    {name: '未取号', list: [], icon: require('../../assets/icon/online/未就绪.png'),btns: getBtns(1)},
                    {name: '已完成', list: [], icon: require('../../assets/icon/online/订单已完成.png'),btns: getBtns(2)},
                ]
            }
        },
        methods:{
            handler(name, data) {
                this.$emit('list-click', name, data);
            },
            initData() {
                let [d0, d1, d2] = this.data;
                d0.list.splice(0);
                d1.list.splice(0);
                d2.list.splice(0);
                this.$set(this.data, 0, d0);
                this.$set(this.data, 1, d1);
                this.$set(this.data, 2, d2);
            },
            setData(val) {
                const that = this;
                this.initData();
                if(val.length == 0)return
                val.forEach((obj) => {
                    let {ddzt} = obj;
                    let [d0, d1, d2] = that.data;
                    if(ddzt == 7){
                        d0.list.push(obj);
                        that.$set(that.data,0,d0);
                    }
                    if(ddzt == 6){
                        d1.list.push(obj);
                        that.$set(that.data,1,d1);
                    }
                    if(ddzt == 5){
                        d2.list.push(obj);
                        that.$set(that.data,2,d2);
                    }
                })
            }
        },
        created() {
            this.setData(this.list);
        },
        watch: {
            list(val) {
                this.setData(val);
            }
        },
    }
</script>

<style scoped>
    .list {
        border-left: 1px solid #ebeef5;
        border-right: 1px solid #ebeef5;
    }
</style>